import { useEffect } from 'react';

export const VIDEO_CONSULTATION_TRIGGER_SEARCH_PARAM_KEY = 'trigger';
export const VIDEO_CONSULTATION_TRIGGER_SESSION_STORAGE_KEY = 'videoConsultationTrigger';

export const useVideoConsultationTrigger = (triggerFromParams: string | null) => {
  const storedTrigger = sessionStorage.getItem(VIDEO_CONSULTATION_TRIGGER_SESSION_STORAGE_KEY);
  const trigger = triggerFromParams?.toLowerCase().trim() || storedTrigger?.toLowerCase().trim() || null;

  useEffect(() => {
    if (trigger && trigger !== storedTrigger) {
      sessionStorage.setItem(VIDEO_CONSULTATION_TRIGGER_SESSION_STORAGE_KEY, trigger);
    }
  }, [trigger, storedTrigger]);

  return { videoConsultationTrigger: trigger };
};
